export const DUBAI_SECTOR = "Aeroglobe - Dubai";
export const RIYADH_SECTOR = "Aeroglobe - Riyadh";
export const DERA_GHAZI_KHAN_SECTOR = "Aeroglobe - Dera Ghazi Khan";
export const SWAT_SECTOR = "Aeroglobe - Swat";
export const RAHIMYAR_KHAN_SECTOR = "Aeroglobe - Rahimyar Khan";
export const GUJRANWALA_SECTOR = "Aeroglobe - Gujranwala";
export const SARGHODA_SECTOR = "Aeroglobe - Sarghoda";
export const MULTAN_SECTOR = "Aeroglobe - Multan";
export const FAISALABAD_SECTOR = "Aeroglobe - Faisalabad";
export const PESHAWAR_SECTOR = "Aeroglobe - Peshawar";
export const SIALKOT_SECTOR = "Aeroglobe - Sialkot";
export const LAHORE_SECTOR = "Aeroglobe - Lahore";
export const ISLAMABAD_SECTOR = "Aeroglobe - Islamabad";
